module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cIA0X"))).then(() => parcelRequire('ikE14'));